// 출입문 "기록 보기" 한 줄 문구. /kiosk/history 응답 한 건을 화면용 텍스트로 바꾼다.
import { formatActorName, formatChangedAt } from "./formatKeepOpenChange";

export type DoorControlHistory = {
  action: "OPEN" | "KEEP_OPEN_ON" | "KEEP_OPEN_OFF";
  success: boolean;
  controlledAt: string; // yyyy-MM-dd'T'HH:mm:ss (서버 로컬 시각)
  managerName: string | null;
  deviceModel: string | null;
};

const ACTION_LABEL: Record<DoorControlHistory["action"], string> = {
  OPEN: "출입문 열기",
  KEEP_OPEN_ON: "상시 문열기 켬",
  KEEP_OPEN_OFF: "상시 문열기 해제",
};

export const formatDoorControlHistory = (
  history: DoorControlHistory,
  currentYear: number = new Date().getFullYear()
) => ({
  actionLabel: ACTION_LABEL[history.action] || "출입문 조작",
  failed: !history.success,
  when: formatChangedAt(history.controlledAt, currentYear),
  // 직원·기종 정보가 없는 기록(로그인 정보 없이 남은 요청)은 '알 수 없음'
  who: formatActorName(history.managerName, history.deviceModel) || "알 수 없음",
});
